import Cropper from "cropperjs";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";

import "cropperjs/dist/cropper.css";

const Base64ImageCropper = ({
  aspectRatio = 1,
  data,
  imageSmoothingEnabled = true,
  imageSmoothingQuality = "high",
  onHide,
  onSave,
  scale,
}) => {
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const cropperRef = useRef(null);

  useEffect(() => {
    if (!imageRef.current) {
      console.error("Base64ImageCropper: image ref is not set");
      return;
    }
    // Initialize Cropper on the image element
    cropperRef.current = new Cropper(imageRef.current, {
      aspectRatio,
    });
    // Cleanup the Cropper instance on unmount
    return () => {
      if (cropperRef.current) {
        cropperRef.current.destroy();
      }
    };
  }, [aspectRatio]);

  const handleSave = () => {
    if (!cropperRef.current) return;
    const { x, y, width, height } = cropperRef.current.getData(true);
    const image = new Image();
    const canvas = canvasRef.current;

    image.src = data;
    image.onload = () => {
      // Use provided scale if available; otherwise default to crop dimensions.
      canvas.width = scale && scale[0] ? scale[0] : width;
      canvas.height = scale && scale[1] ? scale[1] : height;
      const ctx = canvas.getContext("2d");
      ctx.imageSmoothingEnabled = imageSmoothingEnabled;
      if (imageSmoothingEnabled) {
        ctx.imageSmoothingQuality = imageSmoothingQuality;
      }
      // Draw the cropped area onto the canvas
      ctx.drawImage(
        image,
        x,
        y,
        width,
        height,
        0,
        0,
        canvas.width,
        canvas.height,
      );
      // Pass the resulting image (as a data URL) back to the onSave callback
      onSave(canvas.toDataURL("image/png"));
    };
  };

  return (
    <div>
      {/* Hidden canvas for image cropping */}
      <canvas ref={canvasRef} style={{ display: "none" }} />
      <Modal show onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Bijsnijden</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            ref={imageRef}
            height={350}
            src={data}
            alt="Crop area"
            style={{ maxWidth: "100%" }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>Sluiten</Button>
          <Button onClick={() => onSave(data)}>
            Ga verder zonder bijsnijden
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Opslaan
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

Base64ImageCropper.propTypes = {
  aspectRatio: PropTypes.number,
  data: PropTypes.string.isRequired,
  imageSmoothingEnabled: PropTypes.bool,
  imageSmoothingQuality: PropTypes.oneOf(["low", "medium", "high"]),
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  scale: PropTypes.arrayOf(PropTypes.number),
};

export default Base64ImageCropper;
